import {
  FlexibleBlockBrickCountdown,
  FlexibleBlockBrickCountdownStyle,
  FlexibleBlockProps,
  FlexibleBlockTemplateCountdown,
} from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils/blocks';
import { brickCommon } from './common';

export const getCountdownBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateCountdown>[] => {
  const brickCountdown: FlexibleBlockBrickCountdown = {
    ...brickCommon,
    brickType: 'countdown',
    brickName: 'Countdown',
    title: 'Before the event',
    timestamp: Date.now() + 30 * 864e5,
    style: FlexibleBlockBrickCountdownStyle.BOXES,
  };

  return [
    {
      title: 'Countdown',
      wrapper: getWrapperProps('blank'),
      template: { type: 'countdown', view: 'basic' },
      bricks: [{ ...brickCountdown, index: 0 }],
    },
  ];
};
